import { useContext, useEffect, useState } from "react";
import { CardSwapSearchResultDto } from "../dtos/CardSwapSearchResultDto";
import VspPortalContext from "../../../store/VspPortalContext";
import { Asset } from "../../../data/Asset";


export const useCardSwap = ( cardSwapSearchResultDto : CardSwapSearchResultDto ) => {

    const [ cardSwapSearchResult, setCardSwapSearchResult ] = useState< CardSwapSearchResultDto >( cardSwapSearchResultDto );

    const { state } = useContext( VspPortalContext );


    useEffect( () => {

        if( !cardSwapSearchResultDto ) {

            return;

        }

        const cardSwapSearchResult : CardSwapSearchResultDto = {

            id : cardSwapSearchResultDto.id,
            firstName : cardSwapSearchResultDto.firstName,
            email : cardSwapSearchResultDto.email,
            employeeNumber : cardSwapSearchResultDto.employeeNumber,
            newCardNumber : cardSwapSearchResultDto.newCardNumber,
            newCardCollectedDate : cardSwapSearchResultDto.newCardCollectedDate,
            oldCards : [ ...cardSwapSearchResultDto.oldCards ],
            refCardSwapStatusCode : cardSwapSearchResultDto.refCardSwapStatusCode,
            surname : cardSwapSearchResultDto.surname,
            villageCode : state.villages[ Asset.Waio ].find( v => v.villageCode == cardSwapSearchResultDto.villageCode )?.villageName as string,

        };

        setCardSwapSearchResult( cardSwapSearchResult );
        
    }, [ cardSwapSearchResultDto ]);

    return { 

        cardSwapSearchResult
        , setCardSwapSearchResult

    };

};